import script from "./LpTokenPriceChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./LpTokenPriceChart.vue?vue&type=script&setup=true&lang=ts"

import "./LpTokenPriceChart.vue?vue&type=style&index=0&id=74c658d7&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c658d7"]])

export default __exports__